module.exports = __webpack_public_path__ + "static/img/deposit_selected.082ebb12.svg";